<template>
    <div id="productselect">
       <HeaderNav :is_dialogpage="true" :routername="this.$route.name" :addoredirtname="addoredirtname"></HeaderNav>
       
       <div class="room-detail-page">
           <!-- 基本信息卡片 -->
           <div class="info-card">
               <div class="card-header">
                   <span class="card-icon">&#128718;</span>
                   <h3>基本信息</h3>
               </div>
               <div class="card-body">
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">房间名称</span>
                           <span class="info-value">{{ formData.roomName }}</span>
                       </div>
                       <div class="info-item">
                           <span class="info-label">房间分类</span>
                           <span class="info-value">{{ getRoomTypeString(formData.roomType) }}</span>
                       </div>
                   </div>
                   <div class="info-row">
                       <div class="info-item full-width">
                           <span class="info-label">房间描述</span>
                           <span class="info-value">{{ formData.roomDesc }}</span>
                       </div>
                   </div>
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">房间价格</span>
                           <span class="info-value price-value">¥{{ formData.roomPice }} <small>/天</small></span>
                       </div>
                       <div class="info-item">
                           <span class="info-label">房间面积</span>
                           <span class="info-value">{{ formData.roomArea }}m&sup2;</span>
                       </div>
                       <div class="info-item">
                           <span class="info-label">房间容积</span>
                           <span class="info-value">{{ formData.roomSize }}</span>
                       </div>
                   </div>
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">楼层</span>
                           <span class="info-value">{{ formData.roomFloor }}</span>
                       </div>
                       <div class="info-item">
                           <span class="info-label">预约信息</span>
                           <span class="info-value">{{ formData.roomReservation }}</span>
                       </div>
                   </div>
               </div>
           </div>

           <!-- 房型信息卡片 -->
           <div class="info-card">
               <div class="card-header">
                   <span class="card-icon">&#128716;</span>
                   <h3>房型信息</h3>
               </div>
               <div class="card-body">
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">窗户类型</span>
                           <span class="info-value">{{ getRoomWindowTypeString(formData.roomWindowType) }}</span>
                       </div>
                       <div class="info-item">
                           <span class="info-label">床型</span>
                           <span class="info-value">{{ getRoomBedTypeString(formData.roomBedType) }}</span>
                       </div>
                   </div>
                   <div class="info-row">
                       <div class="info-item full-width">
                           <span class="info-label">床型描述</span>
                           <span class="info-value">{{ formData.roomBedDesc }}</span>
                       </div>
                   </div>
               </div>
           </div>

           <!-- 房间设施卡片 -->
           <div class="info-card">
               <div class="card-header">
                   <span class="card-icon">&#9989;</span>
                   <h3>房间设施</h3>
               </div>
               <div class="card-body">
                   <div class="facility-grid">
                       <div class="facility-item" v-for="item in produtAttrlist" :key="item.id">
                           <CheckBox v-model="produtAttrArr" :lable="item.name" :value="item.id" :type="'checkbox1'" :disabled="true"></CheckBox>
                       </div>
                   </div>
               </div>
           </div>

           <!-- 房间图片卡片 -->
           <div class="info-card">
               <div class="card-header">
                   <span class="card-icon">&#128247;</span>
                   <h3>房间图片</h3>
               </div>
               <div class="card-body">
                   <div class="pic-grid">
                       <div class="pic-item" v-for="item,index in formData.roomPic" :key="index" @click="showimg(item)">
                           <img :src="item">
                       </div>
                   </div>
               </div>
           </div>

           <!-- 房间详情卡片 -->
           <div class="info-card">
               <div class="card-header">
                   <span class="card-icon">&#128196;</span>
                   <h3>房间详情</h3>
               </div>
               <div class="card-body">
                   <div class="rich-content" v-html="formData.roomInfo"></div>
               </div>
           </div>

           <!-- 底部按钮 -->
           <div class="form-footer">
               <a href="javascript:void(0)" class="btn-back" @click="closepage(0)">返回</a>
           </div>
       </div>
   </div>
   <div id="showimgbox" v-if="this.showimg_src" @click.self="this.closeshowimgbox">
         <a href="javascript:void(0);" @click="this.closeshowimgbox">关闭</a>
         <img :src="this.showimg_src" @load="loadimgfun" ref="imageElement" :style="{width:this.show_img_width+'px',
            height:this.show_img_height+'px',marginTop:(0-(this.show_img_height/2))+'px',marginLeft:(0-(this.show_img_width/2))+'px'}"></img>
   </div>
</template>

<script>
import HeaderNav from '../common/HeaderNav.vue';
import { ElMessage } from 'element-plus';
import http from '@/tools/Http';
// 请根据实际项目 API 文件路径引入对应的接口
import { selectRoomById} from '@/tools/Api';
import CheckBox from '../common/CheckBox.vue';

export default {
   name: "productselect",
   data() {
       return {
           addoredirtname: "",
           showimg_src: "",
           show_img_width: 0,
           show_img_height: 0,
           inputimgarr: [],//酒店图片
           produtAttrArr: [],
           comkey:0,
           productImg: "",//接受文件控件返回值
           storeList: [],      // 3. 酒店选项列表
           storeDataLoad: false, // 4. 酒店数据加载状态
           
           // 房间分类列表
           categoryList: [
               { id: 1, name: "大床房" },
               { id: 2, name: "主题房" },
               { id: 3, name: "标间" },
               { id: 4, name: "单间" }
           ],
            // 房间床型列表1-大床；2-小床；3-单人床；4-双人床；5-混合
            produtBedTypeList: [
               { id: 1, name: "大床" },
               { id: 2, name: "小床" },
               { id: 3, name: "单人床" },
               { id: 4, name: "双人床" },
               { id: 5, name: "混合" }
           ],
           produtWindowTypeList:[
               { id: 1, name: "有窗" },
               { id: 2, name: "无窗" },
               { id: 3, name: "部分有窗" }
           ],
           produtAttrlist:[
               { id: 1, name: "电视" },
               { id: 2, name: "冰箱" },
               { id: 3, name: "洗衣机" },
               { id: 4, name: "空调" },
               { id: 5, name: "电热水器" },
               { id: 6, name: "书桌" },
               { id: 7, name: "沙发" },
               { id: 8, name: "独立卫浴" },
               { id: 9, name: "衣柜" },
               { id: 10, name: "吹风机" },
               { id: 11, name: "拖鞋" },
               { id: 12, name: "洗漱用品" },
               { id: 13, name: "WIFI" },
               { id: 14, name: "电话" },
               { id: 15, name: "瓶装水" }
           ],
           // 表单数据对象
          formData: {
            roomPic: [],//5
            roomPice: '',//4
            roomArea: '',
            roomAttr: "",
            roomBedDesc: "",
            roomBedType: '',
            roomFloor: "",
            roomInfo: "",//
            roomName: "",//1
            roomReservation: "",
            roomSize: "",
            roomType: '',
            roomWindowType: "",
            roomDesc:'',
            roomStoreId: "",
           },
       };
   },

   components: {
       HeaderNav,
       CheckBox
   },
   props: {
       roomId: { 
           type: [Number, String],
           default: ""
       }
   },
   mounted() {
           this.addoredirtname = "查看";
           this.getProductInfo();

   },
   methods: {
     getRoomTypeString(type){
        let str=''
        this.categoryList.forEach(item=>{
            if(item.id==Number(type)){
                str=item.name
                return
            }
        })
        return str;
          
     },
     getRoomWindowTypeString(type){
        let str=''
        this.produtWindowTypeList.forEach(item=>{
            if(item.id==Number(type)){
                 str=item.name
                return 
            }
        })
          return str;
     },
     getRoomBedTypeString(type){
        let str=''
        this.produtBedTypeList.forEach(item=>{
            if(item.id==Number(type)){
                str=item.name
                return 
            }
        })
        return str;
          
     },
       setProductArrStr(){
          const str=this.formData.roomAttr
          let arr = str.split('');

          for(let i=0;i<arr.length;i++){
            if(arr[i]==1){
                this.produtAttrArr.push(this.produtAttrlist[i].id)
            }
          }
       },
    getProductInfo(){
        selectRoomById({roomId:this.roomId}).then(res => {
            if (res.status == 0) {
                const data = res.data;
                this.formData = {
                    ...res.data
                }
                // 接口返回单位为分，转换为元展示
                if (this.formData.roomPice != null && this.formData.roomPice !== '') {
                    this.formData.roomPice = (Number(this.formData.roomPice) / 100).toFixed(2);
                }
                this.setProductArrStr()
            }else{
                ElMessage({
                    message: res.msg || "操作失败",
                    type: 'error',
                    duration: 1500
                });
            }
        }).catch(error => {
            ElMessage({
                message: "请求失败！",
                type: 'error',
                duration: 1500
            });
        });
    },
    closeshowimgbox(){
        this.showimg_src=""
        this.show_img_width=0
        this.show_img_height=0
    },
    async loadimgfun(){
        let w=0
        let h=0
        const img = new Image()
        img.src = this.showimg_src
        await new Promise((resolve) => {
            img.onload = () => {
                w= img.width
                h= img.height
                if(w>h){ 
                    this.show_img_width=600;
                    this.show_img_height=Math.round(600/w*h);
                }else{
                    this.show_img_height=600;
                    this.show_img_width=Math.round(600/h*w);
                }
                resolve()
            }
        })
    },
    showimg(src){
        this.showimg_src=src;
    },
    closepage(isrush) {
        this.resetForm();
        if (isrush == 1) {
            this.$emit('closerush');
        } else {
            this.$emit('closepage');
        }
    },    
    resetForm() {
        this.formData = {
           roomPic: [],//5
            roomPice: '',//4
            roomArea: '',
            roomAttr: "",
            roomBedDesc: "",
            roomBedType: '',
            roomFloor: "",
            roomInfo: "",//
            roomName: "",//1
            roomReservation: "",
            roomSize: "",
            roomType: '',
            roomWindowType: "",
            roomDesc:'',
            roomStoreId: "",
        };
        if (this.editorRef) {
            this.editorRef.setHtml('');
        }
    }
   }
};
</script>

<style scoped>
#productselect {
   width: 100%;
   height: 100%;
   position: absolute;
   background-color: #f5f6f8;
   left: 0;
   top: 0;
   z-index: 20;
}

.room-detail-page {
   width: 100%;
   height: calc(100% - 40px);
   float: left;
   padding: 24px 40px;
   overflow-y: auto;
   box-sizing: border-box;
}

/* 信息卡片 */
.info-card {
   background: #fff; border-radius: 10px; margin-bottom: 20px;
   box-shadow: 0 2px 12px rgba(0,0,0,0.06); overflow: hidden;
}
.card-header {
   display: flex; align-items: center; gap: 10px;
   padding: 16px 28px; border-bottom: 1px solid #f0f0f0; background: #fafbfc;
}
.card-header h3 { margin: 0; font-size: 16px; color: #333; font-weight: 600; }
.card-icon { font-size: 20px; }
.card-body { padding: 24px 28px; }

/* 信息行 */
.info-row { display: flex; gap: 40px; margin-bottom: 20px; }
.info-row:last-child { margin-bottom: 0; }
.info-item { flex: 1; display: flex; flex-direction: column; gap: 8px; }
.info-item.full-width { flex: none; width: 100%; }
.info-label { font-size: 13px; color: #999; }
.info-value { font-size: 15px; color: #333; font-weight: 500; line-height: 1.6; word-break: break-all; }
.price-value { color: #e57834; font-size: 20px; font-weight: 700; }
.price-value small { font-size: 13px; font-weight: 400; color: #999; }

/* 设施网格 */
.facility-grid { display: flex; flex-wrap: wrap; gap: 8px; }
.facility-item { width: calc(20% - 8px); }

/* 图片网格 */
.pic-grid { display: flex; flex-wrap: wrap; gap: 12px; }
.pic-item {
   width: 150px; height: 110px; border-radius: 8px; overflow: hidden;
   border: 1px solid #eaeaea; cursor: pointer; transition: all 0.3s;
}
.pic-item:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.12); transform: translateY(-2px); }
.pic-item img { width: 100%; height: 100%; object-fit: cover; }

/* 富文本内容 */
.rich-content { font-size: 14px; color: #444; line-height: 1.8; word-break: break-all; }
.rich-content :deep(img) { max-width: 100%; border-radius: 6px; }
.rich-content :deep(p) { max-width: 100%; margin: 0; }

/* 底部按钮 */
.form-footer { display: flex; justify-content: center; gap: 20px; padding: 20px 0 40px; }
.form-footer a {
   display: inline-block; width: 120px; height: 42px; line-height: 42px;
   text-align: center; border-radius: 8px; font-size: 15px; font-weight: 500;
   text-decoration: none; transition: all 0.3s;
}
.btn-back {
   background: #fff; color: #666; border: 1px solid #dcdfe6;
}
.btn-back:hover { color: #12ab04d4; border-color: #12ab04d4; background: #f0f9eb; }

/* 图片全屏预览 */
#showimgbox {
    width: 100%; height: 100%; position: fixed; z-index: 50; top: 0; left: 0;
    background-color: rgba(0,0,0,0.7);
}
#showimgbox img { position: absolute; top: 50%; left: 50%; border-radius: 6px; }
#showimgbox a {
    width: auto; height: 40px; position: absolute; top: 10px; right: 10px;
    display: block; color: #fff; text-align: center; line-height: 40px;
    text-decoration: none; background: rgba(0,0,0,0.4); padding: 0 16px;
    border-radius: 20px; font-size: 14px; transition: background 0.3s;
}
#showimgbox a:hover { background: rgba(0,0,0,0.6); }
</style>